<!-- page starts-->
    <section class="page-wrapper">
      <div class="ashton-hero-shop-section buyticket cf">
         <div class="container">
         	<div class="buyticket-detail">
		        <h3>Avoid the queue and buy your match tickets in advance.</h3>
		        <p>Save time on match day and buy your tickets before you get to the ground. You can print them at home and head straight to the turnstile or show them on your phone.</p>
		    </div>
		    <div class="buyticket-avoid-detail cf">
		    	<div class="buyticket-avoid-box" *ngFor="let ticket of matchticketList?.data">
		    		<div class="buyticket-avoid-left">
		    			<div class="buyticket-avoid-left-image">
		    				<img [src]="ticket?.first_image" [alt]="ticket?.title">
		    			</div>
		    			<h3>${{ticket?.matchticket_general[0]?.amount}}.00</h3>
		    		</div>
		    		<div class="buyticket-avoid-right">
		    			<div class="buyticket-avoid-right-content">
			    			<h3>{{ticket?.title}}</h3>
			    			<p>{{ticket?.date_time | amDateFormat:'dddd D, MMMM  YYYY H:I'}}
			    			</p>
			    		</div>
		    			<div class="buyticket-avoid-right-btn">
		    				<a href="{{ticket?.redirect_url}}" target="_blank">Book Tickets</a>
		    			</div>
		    		</div>
		    	</div>
		    	<!-- <div class="buyticket-avoid-box">
		    		<div class="buyticket-avoid-left">
		    			<div class="buyticket-avoid-left-image">
		    				<img src="assets/images/avoid-image.png">
		    			</div>
		    			<h3>$1.00</h3>
		    		</div>
		    		<div class="buyticket-avoid-right">
		    			<div class="buyticket-avoid-right-content">
			    			<h3>Ashton United Vs Radcliffe Borough</h3>
			    			<p>Tuesday, 8 September 2020 19:45</p>
			    		</div>
		    			<div class="buyticket-avoid-right-btn">
		    				<a href="#">Book Tickets</a>
		    			</div>
		    		</div>
		    	</div>
		    	<div class="buyticket-avoid-box">
		    		<div class="buyticket-avoid-left">
		    			<div class="buyticket-avoid-left-image">
		    				<img src="assets/images/avoid-image.png">
		    			</div>
		    			<h3>$1.00</h3>
		    		</div>
		    		<div class="buyticket-avoid-right">
		    			<div class="buyticket-avoid-right-content">
			    			<h3>Ashton United Vs Radcliffe Borough</h3>
			    			<p>Tuesday, 8 September 2020 19:45</p>
			    		</div>
		    			<div class="buyticket-avoid-right-btn">
		    				<a href="#">Book Tickets</a>
		    			</div>
		    		</div>
		    	</div>
		    	<div class="buyticket-avoid-box">
		    		<div class="buyticket-avoid-left">
		    			<div class="buyticket-avoid-left-image">
		    				<img src="assets/images/avoid-image.png">
		    			</div>
		    			<h3>$1.00</h3>
		    		</div>
		    		<div class="buyticket-avoid-right">
		    			<div class="buyticket-avoid-right-content">
			    			<h3>Ashton United Vs Radcliffe Borough</h3>
			    			<p>Tuesday, 8 September 2020 19:45</p>
			    		</div>
		    			<div class="buyticket-avoid-right-btn">
		    				<a href="#">Book Tickets</a>
		    			</div>
		    		</div>
		    	</div>
		    	<div class="buyticket-avoid-box">
		    		<div class="buyticket-avoid-left">
		    			<div class="buyticket-avoid-left-image">
		    				<img src="assets/images/avoid-image.png">
		    			</div>
		    			<h3>$1.00</h3>
		    		</div>
		    		<div class="buyticket-avoid-right">
		    			<div class="buyticket-avoid-right-content">
			    			<h3>Ashton United Vs Radcliffe Borough</h3>
			    			<p>Tuesday, 8 September 2020 19:45</p>
			    		</div>
		    			<div class="buyticket-avoid-right-btn">
		    				<a href="#">Book Tickets</a>
		    			</div>
		    		</div>
		    	</div>
		    	<div class="buyticket-avoid-box">
		    		<div class="buyticket-avoid-left">
		    			<div class="buyticket-avoid-left-image">
		    				<img src="assets/images/avoid-image.png">
		    			</div>
		    			<h3>$1.00</h3>
		    		</div>
		    		<div class="buyticket-avoid-right">
		    			<div class="buyticket-avoid-right-content">
			    			<h3>Ashton United Vs Radcliffe Borough</h3>
			    			<p>Tuesday, 8 September 2020 19:45</p>
			    		</div>
		    			<div class="buyticket-avoid-right-btn">
		    				<a href="#">Book Tickets</a>
		    			</div>
		    		</div>
		    	</div> -->
		    </div>
           <div class="club-sponsorship-section cf">
             <h2>CLUB SPONSORS</h2>
             <div class="club-sponsorship-detail">
              <ngx-slick-carousel class="carousel " #slickModal="slick-carousel" [config]="slidesponsorConfig">
              	<div ngxSlickItem class="club-sponsorship-box slide" *ngFor="let sponsor of sponsorsList?.data">
                  <div class="club-sponsorship-box-inner">
                     <img [src]="sponsor?.image" [alt]="sponsor?.title">
                  </div>
                </div>
                <!-- <div ngxSlickItem class="club-sponsorship-box slide">
                  <div class="club-sponsorship-box-inner">
                     <img src="assets/images/unnamed-3.jpg" alt="unnamed-3">
                  </div>
                </div>
                <div ngxSlickItem class="club-sponsorship-box slide">
                  <div class="club-sponsorship-box-inner">
                     <img src="assets/images/unnamed-1.jpg" alt="unnamed-1">
                  </div>
                </div>
                <div ngxSlickItem class="club-sponsorship-box slide">
                  <div class="club-sponsorship-box-inner">
                     <img src="assets/images/sponsorship-logo.png" alt="sponsorship-logo">
                  </div>
                </div>
                <div ngxSlickItem class="club-sponsorship-box slide">
                  <div class="club-sponsorship-box-inner">
                     <img src="assets/images/unnamed-9.jpg" alt="unnamed-9">
                  </div>
                </div>
                <div ngxSlickItem class="club-sponsorship-box slide">
                  <div class="club-sponsorship-box-inner">
                     <img src="assets/images/unnamed-2.jpg" alt="unnamed-2">
                  </div>
                </div>
                <div ngxSlickItem class="club-sponsorship-box slide">
                  <div class="club-sponsorship-box-inner">
                     <img src="assets/images/unnamed-3.jpg" alt="unnamed-3">
                  </div>
                </div>
                <div ngxSlickItem class="club-sponsorship-box slide">
                  <div class="club-sponsorship-box-inner">
                     <img src="assets/images/unnamed-1.jpg" alt="unnamed-1">
                  </div>
                </div> -->
              </ngx-slick-carousel>
             </div>
           </div>
           <div class="club-affiliate-section cf">
             <h2>CLUB AFFILIATES</h2>
             <div class="club-affiliate-detail">
                <ul>
                   <li><a href="javascript:void(0);"><img src="assets/images/mcdonnalds.jpg" alt="mcdonnalds"></a></li>
                   <li><a href="javascript:void(0);"><img src="assets/images/respect.jpg" alt="respect"></a></li>
                   <li><a href="javascript:void(0);"><img src="assets/images/logo-logo.jpg" alt="logo-logo"></a></li>
                   <li><a href="javascript:void(0);"><img src="assets/images/respect-logo.jpg" alt="respect-logo"></a></li>
                   <li><a href="javascript:void(0);"><img src="assets/images/logo2-logo2.jpg" alt="logo2-logo2"></a></li>
                   <li><a href="javascript:void(0);"><img src="assets/images/logo3-logo3.jpg" alt="logo3-logo3"></a></li>
                </ul>
             </div>
           </div>
         </div>
      </div>
    </section><!-- page ends-->